(() => {
  'use strict';

  const popup = document.getElementById('country-switch-popup');

  if (!popup) return;

  // -----------------------------
  // Theme Settings
  // -----------------------------

  const enabled = popup.dataset.enabled === 'true';

  if (!enabled) return;

  const targetCountry = (popup.dataset.country || '').trim().toUpperCase();
  const rule = (popup.dataset.rule || 'equals').trim();
  const hideDays = parseInt(popup.dataset.hideDays || '30', 10);

  const STORAGE_KEY = 'country_switch_popup_dismissed';

  // -----------------------------
  // Check Dismiss
  // -----------------------------

  const dismissed = localStorage.getItem(STORAGE_KEY);

  if (dismissed) {
    const diffDays =
      (Date.now() - Number(dismissed)) /
      (1000 * 60 * 60 * 24);

    if (diffDays < hideDays) {
      return;
    }
  }

  // -----------------------------
  // Open Popup
  // -----------------------------

  function openPopup() {
    popup.classList.remove('hidden');

    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  }

  // -----------------------------
  // Close Popup
  // -----------------------------

  function closePopup() {
    popup.classList.add('hidden');

    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');

    localStorage.setItem(
      STORAGE_KEY,
      Date.now().toString()
    );
  }

  // -----------------------------
  // Country Detection
  // -----------------------------

  fetch('/browsing_context_suggestions.json', {
    credentials: 'same-origin'
  })
    .then((response) => response.json())
    .then((data) => {

      console.log('Browsing Context:', data);

      const visitorCountry =
        data?.detected_values?.country?.handle?.toUpperCase();

      console.log('Visitor Country:', visitorCountry);

      if (!visitorCountry) return;

      let shouldShow = false;

      if (rule === 'equals') {
        shouldShow = visitorCountry === targetCountry;
      }

      if (rule === 'not_equals') {
        shouldShow = visitorCountry !== targetCountry;
      }

      if (shouldShow) {
        openPopup();
      }

    })
    .catch((error) => {
      console.error(error);
    });

  // -----------------------------
  // Close Button
  // -----------------------------

  popup
    .querySelector('.country-popup__close')
    ?.addEventListener('click', closePopup);

  // -----------------------------
  // Overlay
  // -----------------------------

  popup
    .querySelector('.country-popup__overlay')
    ?.addEventListener('click', closePopup);

  // -----------------------------
  // Continue Browsing Button
  // -----------------------------

  const secondaryWrapper =
    popup.querySelector('.country-popup__secondary');

  if (secondaryWrapper) {

    const button =
      secondaryWrapper.querySelector('button, a');

    if (button) {
      button.addEventListener('click', closePopup);
    }

  }

})();